import * as React from 'react';

const useAudioState = (audio: HTMLAudioElement) => {
  const [state, setState] = React.useState<'paused' | 'playing'>(
    audio.paused ? 'paused' : 'playing',
  );

  React.useEffect(() => {
    const onPause = () => {
      setState('paused');
    };
    const onPlaying = () => {
      setState('playing');
    };
    audio.addEventListener('pause', onPause);
    audio.addEventListener('playing', onPlaying);
    setState(audio.paused ? 'paused' : 'playing');
    return () => {
      audio.removeEventListener('pause', onPause);
      audio.removeEventListener('playing', onPlaying);
    };
  }, [audio]);

  return state;
};

export default useAudioState;
